module.exports = __webpack_public_path__ + "img/dental-pro.png";